// Define the action type
type ActionType = {
  type: string;
  payload?: any; // Adjust payload type as needed
};

// Define the makeAction function
export const makeActionDefault = (payload?: any): ActionType => ({
  type: '',
  payload,
});

// Define the action function
export const action = (type: string, makeAction = makeActionDefault) => {
  const actionCreator = (...args: any[]): ActionType => {
    const action = makeAction(...args);
    if (typeof action === 'object') {
      action.type = type;
    }
    return action;
  };
  actionCreator.type = type;
  return actionCreator;
};

export const asyncAction = (base, makeAction = makeActionDefault) => {
  const actionCreator = (...args): ActionType => {
    const action = makeAction(...args);
    if (typeof action === 'object') {
      action.type = base;
    }

    return action;
  };

  actionCreator.type = base;
  actionCreator.request = `${base}/REQUEST`;
  actionCreator.success = `${base}/SUCCESS`;
  actionCreator.failure = `${base}/FAILURE`;

  return actionCreator;
};
